import {Accordion, AccordionTab} from "primereact/accordion";
import ReportItem from "./ReportItem";
import {ReportItemData} from "../../../../types/demo";

interface Props {
    header: string;
    items: ReportItemData[];
    favorites: ReportItemData[];
    onToggleFavorite: (item: ReportItemData) => void;
    isOpen: boolean;
    onToggle: (isOpen: boolean) => void;
}

const RegularAccordion = ({ header, items, favorites, onToggleFavorite, isOpen, onToggle }: Props) => {
    return (
        <Accordion
            activeIndex={isOpen ? 0 : null}
            onTabChange={(e) => onToggle(e.index === 0)}
        >
            <AccordionTab  header={header}>
                <div className="pr-2 flex flex-column">
                    {items.map((item) => (
                        <ReportItem
                            key={`${header}-${item.label}`}
                            item={item}
                            isFavorite={favorites.some(f => f.label === item.label)}
                            onToggleFavorite={onToggleFavorite}
                        />
                    ))}
                </div>
            </AccordionTab>
        </Accordion>
    );
};
export default RegularAccordion;